import { render, staticRenderFns } from "./TitleToolbar.vue?vue&type=template&id=637170b4&scoped=true"
import script from "./TitleToolbar.vue?vue&type=script&lang=js"
export * from "./TitleToolbar.vue?vue&type=script&lang=js"
import style0 from "./TitleToolbar.vue?vue&type=style&index=0&id=637170b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637170b4",
  null
  
)

export default component.exports